export const transmissions = [
  { value: '0AC', text: 'CVTコラムシフト' },
  { value: '0AD', text: 'CVTダッシュボードシフト' },
  { value: '0AF', text: 'CVTフロアシフト' },
  { value: '10AF', text: '10段変速オートマチックフロアシフト' },
  { value: '3AC', text: '3段変速オートマチックコラムシフト' },
  { value: '3AD', text: '3段変速オートマチックダッシュボードシフト' },
  { value: '3AF', text: '3段変速オートマチックフロアシフト' },
  { value: '4AC', text: '4段変速オートマチックコラムシフト' },
  { value: '4AD', text: '4段変速オートマチックダッシュボードシフト' },
  { value: '4AF', text: '4段変速オートマチックフロアシフト' },
  { value: '4MC', text: '4段変速マニュアルコラムシフト' },
  { value: '4MF', text: '4段変速マニュアルフロアシフト' },
  { value: '5AC', text: '5段変速オートマチックコラムシフト' },
  { value: '5AD', text: '5段変速オートマチックダッシュボードシフト' },
  { value: '5AF', text: '5段変速オートマチックフロアシフト' },
  { value: '5MC', text: '5段変速マニュアルコラムシフト' },
  { value: '5MD', text: '5段変速マニュアルダッシュボードシフト' },
  { value: '5MF', text: '5段変速マニュアルフロアシフト' },
  { value: '6AC', text: '6段変速オートマチックコラムシフト' },
  { value: '6AD', text: '6段変速オートマチックダッシュボードシフト' },
  { value: '6AF', text: '6段変速オートマチックフロアシフト' },
  { value: '6MD', text: '6段変速マニュアルダッシュボードシフト' },
  { value: '6MF', text: '6段変速マニュアルフロアシフト' },
  { value: '7AC', text: '7段変速オートマチックコラムシフト' },
  { value: '7AD', text: '7段変速オートマチックダッシュボードシフト' },
  { value: '7AF', text: '7段変速オートマチックフロアシフト' },
  { value: '7MF', text: '7段変速マニュアルフロアシフト' },
  { value: '8AC', text: '8段変速オートマチックコラムシフト' },
  { value: '8AD', text: '8段変速オートマチックダッシュボードシフト' },
  { value: '8AF', text: '8段変速オートマチックフロアシフト' },
  { value: '9AC', text: '9段変速オートマチックコラムシフト' },
  { value: '9AF', text: '9段変速オートマチックフロアシフト' },
];

export const catalogEquipment = [
  { field: 'Abs', value: '1', text: 'ABS' },
  { field: 'Abs', value: '2', text: 'ABS + EBD' },
  { field: 'Abs', value: '3', text: 'ABS + EBD + VCD' },
  { field: 'Abs', value: '4', text: 'ABS + VCD' },
  { field: 'TV', value: '1', text: 'TV付' },
  { field: 'アルミホイール', value: '1', text: 'アルミ有(インチ不明)' },
  { field: 'アルミホイール', value: '2', text: '12インチアルミホイール' },
  { field: 'アルミホイール', value: '3', text: '13インチアルミホイール' },
  { field: 'アルミホイール', value: '4', text: '14インチアルミホイール' },
  { field: 'アルミホイール', value: '5', text: '15インチアルミホイール' },
  { field: 'アルミホイール', value: '6', text: '16インチアルミホイール' },
  { field: 'アルミホイール', value: '7', text: '17インチアルミホイール' },
  { field: 'アルミホイール', value: '8', text: '18インチアルミホイール' },
  { field: 'アルミホイール', value: '9', text: '19インチアルミホイール' },
  { field: 'エアコン', value: '1', text: 'マニュアルエアコン' },
  { field: 'エアコン', value: '2', text: 'オートエアコン' },
  { field: 'エアコン', value: '3', text: 'デュアルエアコン' },
  { field: 'エアコン', value: '4', text: 'オートデュアルエアコン' },
  { field: 'EqAirbag', value: '1', text: 'エアバッグ付' },
  { field: 'EqAirbag', value: '2', text: '運転席・助手席エアバッグ装備' },
  { field: 'EqAirbag', value: '3', text: '運転席・助手席・サイドエアバッグ装備' },
  { field: 'EqAirbag', value: '4', text: '運転席・助手席・サイド・後席エアバッグ装備' },
  { field: 'EqAirbag', value: '5', text: '運転席エアバッグ装備' },
  { field: 'サンルーフ', value: '1', text: 'サンルーフ' },
  { field: 'サンルーフ', value: '2', text: 'トリプルムーンルーフ' },
  { field: 'サンルーフ', value: '3', text: 'パノラマルーフ' },
  { field: 'サンルーフ', value: '4', text: 'Tバールーフ' },
  { field: 'サンルーフ', value: '5', text: 'ツインサンルーフ' },
  { field: 'ステレオ', value: '1', text: 'オーディオ付' },
  { field: 'ステレオ', value: '2', text: 'CD' },
  { field: 'ステレオ', value: '3', text: 'CD or MD' },
  { field: 'ステレオ', value: '4', text: 'ラジオ' },
  { field: 'ナビ', value: '1', text: 'ナビ付(種類不明)' },
  { field: 'ナビ', value: '2', text: 'CDナビ' },
  { field: 'ナビ', value: '3', text: 'DVDナビ' },
  { field: 'ナビ', value: '4', text: 'HDDナビ' },
  { field: 'ナビ', value: '5', text: 'ツインDVDナビ' },
  { field: 'ナビ', value: '6', text: 'ツインHDDナビ' },
  { field: 'パワーウィンドウ', value: '1', text: '標準装備' },
  { field: 'パワーウィンドウ', value: '2', text: '前席' },
  { field: 'パワーウィンドウ', value: '3', text: '運転席' },
  { field: 'パワーシート', value: '1', text: '運転席パワーシート' },
  { field: 'EqPowerSteering', value: '1', text: '標準装備' },
  { field: 'EqPowerSteering', value: '2', text: '電子制御' },
  { field: 'リアスポイラー', value: '1', text: 'リアスポイラー付' },
  { field: '本革', value: '1', text: '本革付' },
  { field: '空気清浄機', value: '1', text: '空気清浄機付' },
  { field: 'EqAbs', value: '●', text: 'ＡＢＳ装着' },
  { field: 'EqAbs', value: 'E', text: 'ＡＢＳ＋ＥＢＤ装着' },
  { field: 'EqAbs', value: 'EV', text: 'ＡＢＳ＋ＥＢＤ＋ＶＣＤ' },
  { field: 'EqAbs', value: 'V', text: 'ＡＢＳ＋ＶＣＤ' },
  { field: 'AC', value: '×', text: 'エアコン取付不可' },
  { field: 'AC', value: '●', text: 'マニュアルエアコン装備' },
  { field: 'AC', value: 'A', text: 'オートエアコン装備' },
  { field: 'AC', value: 'D', text: 'デュアルマニュアルエアコン装備' },
  { field: 'AC', value: 'DA', text: 'デュアルフルオートエアコン装備' },
  { field: 'EqAircondition', value: '×', text: 'エアコン取付不可' },
  { field: 'EqAircondition', value: '●', text: 'マニュアルエアコン装備' },
  { field: 'EqAircondition', value: 'A', text: 'オートエアコン装備' },
  { field: 'EqAircondition', value: 'D', text: 'デュアルマニュアルエアコン装備' },
  { field: 'EqAircondition', value: 'DA', text: 'デュアルフルオートエアコン装備' },
  { field: 'AW', value: '●', text: 'アルミホイール装備' },
  { field: 'AW', value: '0A', text: '２０インチアルミホイール装備' },
  { field: 'AW', value: '0C', text: '２０インチ鋳造アルミホイール装備' },
  { field: 'AW', value: '0K', text: '２０インチ光輝アルミホイール装備' },
  { field: 'AW', value: '0T', text: '２０インチ鍛造アルミホイール装備' },
  { field: 'AW', value: '1A', text: '２１インチアルミホイール装備' },
  { field: 'AW', value: '1C', text: '２１インチ鋳造アルミホイール装備' },
  { field: 'AW', value: '1K', text: '２１インチ光輝アルミホイール装備' },
  { field: 'AW', value: '1T', text: '２１インチ鍛造アルミホイール装備' },
  { field: 'AW', value: '2A', text: '２２インチアルミホイール装備' },
  { field: 'AW', value: '2C', text: '２２インチ鋳造アルミホイール装備' },
  { field: 'AW', value: '2K', text: '２２インチ光輝アルミホイール装備' },
  { field: 'AW', value: '2T', text: '２２インチ鍛造アルミホイール装備' },
  { field: 'AW', value: '3A', text: '１３インチアルミホイール装備' },
  { field: 'AW', value: '3C', text: '１３インチ鋳造アルミホイール装備' },
  { field: 'AW', value: '3K', text: '１３インチ光輝アルミホイール装備' },
  { field: 'AW', value: '3T', text: '１３インチ鍛造アルミホイール装備' },
  { field: 'AW', value: '4A', text: '１４インチアルミホイール装備' },
  { field: 'AW', value: '4C', text: '１４インチ鋳造アルミホイール装備' },
  { field: 'AW', value: '4K', text: '１４インチ光輝アルミホイール装備' },
  { field: 'AW', value: '4T', text: '１４インチ鍛造アルミホイール装備' },
  { field: 'AW', value: '5A', text: '１５インチアルミホイール装備' },
  { field: 'AW', value: '5C', text: '１５インチ鋳造アルミホイール装備' },
  { field: 'AW', value: '5K', text: '１５インチ光輝アルミホイール装備' },
  { field: 'AW', value: '5T', text: '１５インチ鍛造アルミホイール装備' },
  { field: 'AW', value: '6A', text: '１６インチアルミホイール装備' },
  { field: 'AW', value: '6C', text: '１６インチ鋳造アルミホイール装備' },
  { field: 'AW', value: '6K', text: '１６インチ光輝アルミホイール装備' },
  { field: 'AW', value: '6T', text: '１６インチ鍛造アルミホイール装備' },
  { field: 'AW', value: '7A', text: '１７インチアルミホイール装備' },
  { field: 'AW', value: '7C', text: '１７インチ鋳造アルミホイール装備' },
  { field: 'AW', value: '7K', text: '１７インチ光輝アルミホイール装備' },
  { field: 'AW', value: '7T', text: '１７インチ鍛造アルミホイール装備' },
  { field: 'AW', value: '8A', text: '１８インチアルミホイール装備' },
  { field: 'AW', value: '8C', text: '１８インチ鋳造アルミホイール装備' },
  { field: 'AW', value: '8K', text: '１８インチ光輝アルミホイール装備' },
  { field: 'AW', value: '8T', text: '１８インチ鍛造アルミホイール装備' },
  { field: 'AW', value: '9A', text: '１９インチアルミホイール装備' },
  { field: 'AW', value: '9C', text: '１９インチ鋳造アルミホイール装備' },
  { field: 'AW', value: '9K', text: '１９インチ光輝アルミホイール装備' },
  { field: 'AW', value: '9T', text: '１９インチ鍛造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '●', text: 'アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '0A', text: '２０インチアルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '0C', text: '２０インチ鋳造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '0K', text: '２０インチ光輝アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '0T', text: '２０インチ鍛造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '1A', text: '２１インチアルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '1C', text: '２１インチ鋳造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '1K', text: '２１インチ光輝アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '1T', text: '２１インチ鍛造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '2A', text: '２２インチアルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '2C', text: '２２インチ鋳造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '2K', text: '２２インチ光輝アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '2T', text: '２２インチ鍛造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '3A', text: '１３インチアルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '3C', text: '１３インチ鋳造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '3K', text: '１３インチ光輝アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '3T', text: '１３インチ鍛造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '4A', text: '１４インチアルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '4C', text: '１４インチ鋳造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '4K', text: '１４インチ光輝アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '4T', text: '１４インチ鍛造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '5A', text: '１５インチアルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '5C', text: '１５インチ鋳造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '5K', text: '１５インチ光輝アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '5T', text: '１５インチ鍛造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '6A', text: '１６インチアルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '6C', text: '１６インチ鋳造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '6K', text: '１６インチ光輝アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '6T', text: '１６インチ鍛造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '7A', text: '１７インチアルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '7C', text: '１７インチ鋳造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '7K', text: '１７インチ光輝アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '7T', text: '１７インチ鍛造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '8A', text: '１８インチアルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '8C', text: '１８インチ鋳造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '8K', text: '１８インチ光輝アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '8T', text: '１８インチ鍛造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '9A', text: '１９インチアルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '9C', text: '１９インチ鋳造アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '9K', text: '１９インチ光輝アルミホイール装備' },
  { field: 'EqAluminiumWheel', value: '9T', text: '１９インチ鍛造アルミホイール装備' },
  { field: 'EqPowerSeats', value: 'B', text: '後席のみパワーシート装備' },
  { field: 'EqPowerSeats', value: 'Ｄ', text: '運転席・助手席パワーシート装備' },
  { field: 'EqPowerSeats', value: 'D', text: '運転席・助手席パワーシート装備' },
  { field: 'EqPowerSeats', value: 'DB', text: '運転席・助手席・後席パワーシート装備' },
  { field: 'EqPowerSeats', value: 'Ｓ', text: '運転席パワーシート装備' },
  { field: 'EqPowerSeats', value: 'S', text: '運転席パワーシート装備' },
  { field: 'EqPowerSeats', value: 'SB', text: '運転席・後席パワーシート装備' },
  { field: 'EqPowerSteering', value: '●', text: 'パワーステアリング装備' },
  { field: 'EqPowerSteering', value: 'E', text: '電子制御パワーステアリング装備' },
  { field: 'PW', value: '●', text: 'パワーウィンドー装備' },
  { field: 'PW', value: 'D', text: '運転席・助手席のみパワーウインドー装備' },
  { field: 'PW', value: 'S', text: '運転席のみパワーウインドー装備' },
  { field: 'SR', value: '●', text: 'サンルーフ装備' },
  { field: 'SR', value: 'M', text: 'ムーンルーフ装備' },
  { field: 'SR', value: 'P', text: 'パノラマルーフ装着' },
  { field: 'SR', value: 'T', text: 'Ｔバールーフ装備' },
  { field: 'SR', value: 'TM', text: 'トリプルムーンルーフ装備' },
  { field: 'SR', value: 'W', text: 'ツインサンルーフ装着' },
  { field: 'SR', value: 'WM', text: 'ツインムーンルーフ装備' },
  { field: 'EqAirbag', value: '●', text: 'エアバッグ装備' },
  { field: 'EqAirbag', value: 'C', text: '運転席・助手席エアバック・サイドエアバッグ・カーテンエアバッグ装着' },
  { field: 'EqAirbag', value: 'D', text: '運転席・助手席エアバッグ装着' },
  { field: 'EqAirbag', value: 'D3', text: '運転席・助手席エアバッグ装備、運転席・後席サイドエアバッグ装備' },
  { field: 'EqAirbag', value: 'D4', text: '運転席・助手席エアバッグ装備、前・後席サイドエアバッグ装備' },
  { field: 'EqAirbag', value: 'DB', text: '運転席・助手席エアバッグ・後席サイドエアバッグ装備' },
  { field: 'EqAirbag', value: 'DD', text: '運転席・助手席エアバッグ・サイドエアバッグ装備' },
  { field: 'EqAirbag', value: 'DK', text: '運転席・助手席エアバック・サイドエアバッグ・ニーエアバッグ装着' },
  { field: 'EqAirbag', value: 'K', text: '運転席・助手席エアバック・ニーエアバッグ装着' },
  { field: 'EqAirbag', value: 'S', text: '運転席のみ' },
  { field: 'EqStereo', value: '●', text: 'オーディオ関連装備' },
  { field: 'EqStereo', value: 'A1', text: 'ＭＤ／ＭＤチェンジャー' },
  { field: 'EqStereo', value: 'A2', text: 'ＭＤ／カセットステレオ／ＭＤチェンジャー' },
  { field: 'EqStereo', value: 'A3', text: 'ＭＤ／ＣＤ／ＭＤチェンジャー' },
  { field: 'EqStereo', value: 'A4', text: 'ＭＤ／ＣＤ／ＭＤチェンジャー／ＣＤチェンジャー' },
  { field: 'EqStereo', value: 'A5', text: 'ＭＤ／ＣＤ／カセットステレオ／ＭＤチェンジャー' },
  { field: 'EqStereo', value: 'A6', text: 'ＭＤ／ＣＤ／カセットステレオ／ＭＤチェンジャー／ＣＤチェンジャー' },
  { field: 'EqStereo', value: 'C1', text: 'ＣＤ' },
  { field: 'EqStereo', value: 'C2', text: 'ＣＤ／カセットステレオ' },
  { field: 'EqStereo', value: 'C3', text: 'ＣＤ／ＣＤチェンジャー' },
  { field: 'EqStereo', value: 'C4', text: 'ＣＤ／カセットステレオ／ＣＤチェンジャー' },
  { field: 'EqStereo', value: 'M1', text: 'ＭＤ' },
  { field: 'EqStereo', value: 'M2', text: 'ＭＤ／カセットステレオ' },
  { field: 'EqStereo', value: 'M3', text: 'ＭＤ／ＣＤ' },
  { field: 'EqStereo', value: 'M4', text: 'ＭＤ／ＣＤ／ＣＤチェンジャー' },
  { field: 'EqStereo', value: 'M5', text: 'ＭＤ／カセットステレオ／ＣＤ' },
  { field: 'EqStereo', value: 'M6', text: 'ＭＤ／カセットステレオ／ＣＤ／ＣＤチェンジャー' },
  { field: 'EqStereo', value: 'R', text: 'ラジオのみ装備（ＡＭ・ＦＭ種別なし）' },
  { field: 'EqTv', value: '●', text: 'ＴＶ付' },
  { field: 'EqNavigation', value: '●', text: 'ナビ付' },
  { field: 'EqNavigation', value: 'SC', text: 'ＣＤナビ' },
  { field: 'EqNavigation', value: 'SD', text: 'ＤＶＤナビ' },
  { field: 'EqNavigation', value: 'SH', text: 'ＨＤＤナビ' },
  { field: 'EqNavigation', value: 'TD', text: 'ＤＶＤナビ（ツインモニター）' },
  { field: 'EqNavigation', value: 'TH', text: 'ＨＤＤナビ（ツインモニター）' },
  { field: 'フルエアロ', value: '●', text: 'フルエアロ' },
  { field: '本革', value: '●', text: '本革付' },
  { field: '空気清浄機', value: '●', text: '空気清浄機付' },
  { field: 'キャビン', value: 'D', text: 'ダブルキャビン' },
  { field: 'キャビン', value: 'E', text: 'エクストラキャビン' },
  { field: 'キャビン', value: 'H', text: 'ハイキャビン' },
  { field: 'キャビン', value: 'K', text: 'キングキャビン' },
  { field: 'キャビン', value: 'N', text: '標準キャビン' },
  { field: 'キャビン', value: 'ND', text: '標準ダブルキャビン' },
  { field: 'キャビン', value: 'NH', text: '標準ハイキャビン' },
  { field: 'キャビン', value: 'NT', text: '標準ハイトップダブルキャビン' },
  { field: 'キャビン', value: 'S', text: 'シングルキャビン' },
  { field: 'キャビン', value: 'SW', text: 'スーパーワイドキャビン' },
  { field: 'キャビン', value: 'TD', text: 'ハイトップダブルキャビン' },
  { field: 'キャビン', value: 'W', text: 'ワイドキャビン' },
  { field: 'キャビン', value: 'WD', text: 'ワイドダブルキャビン' },
  { field: 'タイヤ種類', value: 'HS', text: '扁平シングルタイヤ' },
  { field: 'タイヤ種類', value: 'HW', text: '扁平ダブルタイヤ' },
  { field: 'タイヤ種類', value: 'S', text: 'シングルタイヤ' },
  { field: 'タイヤ種類', value: 'SW', text: '小径ダブルタイヤ' },
  { field: 'タイヤ種類', value: 'W', text: 'ダブル' },
  { field: 'RoofType', value: 'H', text: 'ハイルーフ' },
  { field: 'RoofType', value: 'L', text: 'ロールーフ' },
  { field: 'RoofType', value: 'M', text: 'ミッドルーフ' },
  { field: 'RoofType', value: 'SH', text: 'スーパーハイルーフ' },
  { field: 'RoofType', value: '標', text: '標準ルーフ' },
  { field: '床式名称', value: 'FF', text: 'フルフラットロー' },
  { field: '床式名称', value: 'FJ', text: 'フルジャストロー' },
  { field: '床式名称', value: 'FL', text: 'フラットロー' },
  { field: '床式名称', value: 'FS', text: 'フルスーパーロー' },
  { field: '床式名称', value: 'FW', text: 'フルワイドロー' },
  { field: '床式名称', value: 'JL', text: 'ジャストロー' },
  { field: '床式名称', value: 'SJ', text: 'スーパージャストロー' },
  { field: '床式名称', value: 'SL', text: 'スーパーロー' },
  { field: '床式名称', value: 'SW', text: 'スーパーワイドロー' },
  { field: '床式名称', value: 'WL', text: 'ワイドロー' },
  { field: '床式名称', value: '低', text: '低床' },
  { field: '床式名称', value: '全', text: '全低床' },
  { field: '床式名称', value: '平', text: '平低床' },
  { field: '床式名称', value: '超', text: '超低床' },
  { field: '床式名称', value: '高', text: '高床' },
  { field: '荷台材料', value: 'A', text: 'アルミ' },
  { field: '荷台材料', value: 'F', text: 'ＦＲＰ製' },
  { field: '荷台材料', value: 'S', text: 'スチール' },
  { field: '荷台材料', value: '木', text: '木製' },
  { field: 'FuelId', value: 'C', text: '天然ガス' },
  { field: 'FuelId', value: 'D', text: 'ディーゼル' },
  { field: 'FuelId', value: 'DH', text: 'ディーゼル（ハイブリッド）' },
  { field: 'FuelId', value: 'E', text: '電気' },
  { field: 'FuelId', value: 'F', text: '燃料電池' },
  { field: 'FuelId', value: 'G', text: 'ガソリン' },
  { field: 'FuelId', value: 'GH', text: 'ガソリン（ハイブリッド）' },
  { field: 'FuelId', value: 'H', text: 'ハイブリッド' },
  { field: 'FuelId', value: 'L', text: 'LPガス' },
];

export const fieldsForInspectors = /(Eq|Sheet|Roof|Fog|Keyless|Wheel|Power|Mirror|ModelNameJp|Leather|Sale|Roof|Name|Transmission|Grade|Aero|Abs|Emission|Drive|Doors|Humans)/i;

export const equipment = {
  A_W: 'EqAluminiumWheel',
  NAVIGATION: 'EqNavigation',
  P_S: 'EqPowerSteering',
  P_W: 'EqPowerWindow',
  S_R: 'EqSr',
  TV: 'EqTv',
  ELECTRIC_EXTERIOR_MIRRORS: 'EqElectricDoorMirror',
};
export const salesPoints = {
  KEYLESS: 'EqKeylessEntry',
  POWER_SEAT: 'EqPowerSeats',
  PUSH_STRT: 'PushEngineStartExisting',
  SEAT_HEATER: 'HeaterSheet',
};



// WEBPACK FOOTER //
// ./src/components/picker-options.js